import React, { useState, useEffect, useContext } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import TableAllData from "components/Content/CustomTable/TableAllData";
import { apiGet } from "app/Services/ApiService";
import { apiUrls, employeeApiUrls } from "common/ApiUrls";
import { CloudDownloadOutlined } from "@mui/icons-material";
import TableStyle from "components/Content/Table/TableStyle.module.css";

import moment from "moment";
import AximTooltip from "components/AximTooltip";

export default function Files() {
    const [isLoading, setIsLoading] = useState(true);
    const [files, setFiles] = useState([]);
    const [doShowError, setDoShowError] = useState(false);
    const [errorText, setErrorText] = useState("");
    const [hasInitializationError, setHasInitializationError] = useState(false);

    useEffect(() => {
        apiGet(employeeApiUrls.getFiles).then(
            (response) => {
              setFiles(response.data);
              setIsLoading(false);
            }
          )
          .catch(e => {
              console.log(e);
              setHasInitializationError(true);
          });
    },[])

    const columns = [
        {
          Header: "",
          accessor: "fileId",
          Cell: e =>
            <AximTooltip title="Download File">
              <IconButton onClick={() => downloadFile(`${e.value}`, `${e.row.values.fileName}`)} color="primary"><CloudDownloadOutlined /></IconButton>
            </AximTooltip>,
          maxWidth: 100,
          disableFilters: true,
        },
        {
          Header: "File Name",
          accessor: "fileName",
        },
        {
          Header: "Upload Date",
          accessor: (cell) => moment(cell.uploadDate).format("MM/DD/yyyy hh:mm:ss A"), // You format date here
        },
        {
          Header: "Update Date",
          accessor: (cell) => moment(cell.updateDate).format("MM/DD/yyyy hh:mm:ss A"),
        },
      ];

    const downloadFile = (fileId, fileName) => {
      apiGet(apiUrls.downloadFile('', fileId), { responseType: "blob" }).then(response => {
  
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
  
        console.log("File downloading successfully");
      }).catch(
        (response) => {
          setErrorText("An Error occurred downloading the file.");
          setDoShowError(true);
        }
      );
    }

    
    const handleClose = () => {
        setDoShowError(false);
    }

    return (
        <Box>
          {hasInitializationError ? <h4>Error Loading File List</h4>
          : <Box className={TableStyle.tableWrapper}>
              <TableAllData columns={columns} data={files} isLoading={isLoading} />
            </Box>
          }
            
          <Dialog
            open={doShowError}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"An Error Occurred"}</DialogTitle>
            <DialogContent>
              {errorText}
            </DialogContent>

            <DialogActions>
            <Button onClick={handleClose} color="primary" variant="outlined">
                Close
            </Button>
            </DialogActions>
          </Dialog>
        </Box>
    )
}